module.exports = __webpack_public_path__ + "static/media/hero-11.d8986072.png";